export const APP_URL_API = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_URL_API_LOCAL : process.env.VUE_APP_URL_API_PRODUCTION
